module.exports = __webpack_public_path__ + "assets/img/33_1568.3cc24ff6.jpg";